import { Container, Row, Col} from "react-bootstrap"


function HowToUse() {
    const MyStyle =  {
        color: "black",
        fontSize: "3.5vmin"        
    }

    const MyStyle2 =  {
        color: "white",
        fontSize: "2.5vmin"        
    }


    return (        
        <Container fluid style={{backgroundColor: "#afc7c7"}}>
            <Row>
                <Col style={{margin: "0% 0% 0% 0%", textAlign: "right", padding: "0px"}}>
                    
                </Col>
                <Col style={{margin: "3% 0% 0% 0%", textAlign: "left"}}>
                    <div style={MyStyle}>Die Idee</div>                    
                </Col>
            </Row>    
            <Row style={{margin: "0% 3% 3% 3%"}}>                
                <Col style={{textAlign: "Left"}}>
                    <div style={MyStyle2}>
                        <br/>
                        <p>
                            Anders als bei einem Notrufsystem ist bei der MessageBox die Idee, dass man in stetigem Kontakt bleibt.<br/>
                            Die Angehörigen sollen regelmäßig die Nachrichten der MessageBox erhalten.<br/>
                            Dabei geht es nicht darum die Person zu kontrollieren, sondern Klarheit darüber zu bekommen, ob Hilfe erforderlich ist.<br/>
                            Nichts schöner als am morgen eine "grüne" Nachricht zu erhalten und damit zu wissen, die Person ist auf und es ist alles okay.<br/>
                            Aus eigener Erfahrung können wir sagen, dass es sinnvoll ist, feste Zeitfenster für eine Benachrichtigung zu vereinbaren,
                            beispielsweise morgens bis spätestens 9:30 Uhr und Abends zwischen 19:00 Uhr und 21:30 Uhr.<br/>
                            Sollte die Person sich nicht melden besteht die Möglichkeit, über den Telegram-Chat der MessageBox eine Erinnerungsmelody auf der MessageBox 
                            abspielen zu lassen.
                            Wenn dann keine Reaktion erfolgt kann man einen Anruf tätigen.<br/>
                            Im Idealfall wird das Drücken eines Tasters zum morgendlichen und abendlichen Ritual.
                            <br/>
                            <br/>
                            <br/>                            
                        </p>                       
                    </div>                                                                                               
                </Col>
            </Row>                        
        </Container>
    )
}

export default HowToUse;